import React from 'react';

const CollectionHeading = ({ title, emphasizedTitlePart }) => (
  <div className="collection-ng__title-wrapper">
    <div className="collection-ng__title-item collection-ng__title-item--grower">
      <h3 className="collection-ng__heading">
        {emphasizedTitlePart && (
          <span className="collection-ng__heading-em">
            {emphasizedTitlePart}
          </span>
        )}
        {title}
      </h3>
    </div>
  </div>
);

export default CollectionHeading;
